interface GearInsidePersonTalkingSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GearInsidePersonTalkingSVG = ({
  color,
  style,
}: GearInsidePersonTalkingSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="50"
    viewBox="0 0 53 50"
    fill="none"
  >
    <g clipPath="url(#clip0_1753_14971)">
      <path
        d="M22.0791 14.5093C22.0791 17.9693 19.2671 20.7812 15.8071 20.7812C12.3471 20.7812 9.53516 17.9693 9.53516 14.5093C9.53516 11.0493 12.3471 8.2373 15.8071 8.2373C19.2671 8.2373 22.0791 11.0493 22.0791 14.5093Z"
        stroke={color}
        strokeWidth="1.23023"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.19531 23.6491L7.64522 25.077C8.2164 25.6482 9.13907 25.6372 9.71025 25.066L11.1821 23.5832C12.632 24.407 14.3016 24.8793 16.0921 24.8683L16.6413 26.8784C16.85 27.6583 17.6628 28.1087 18.4317 27.9L20.6615 27.2848C21.4414 27.0761 21.8917 26.2633 21.683 25.4944L21.1338 23.4733C22.6167 22.5946 23.8359 21.3534 24.6927 19.8705L26.7138 20.3978C27.4936 20.6065 28.2955 20.1341 28.4932 19.3543L29.0754 17.1245C29.2841 16.3446 28.8117 15.5427 28.0319 15.345L26.0108 14.8178C25.9888 13.0384 25.5055 11.3688 24.6597 9.92983L26.1316 8.44697C26.7028 7.87579 26.6918 6.95312 26.1206 6.38194L25.3957 5.66797"
        stroke={color}
        strokeWidth="1.23023"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5834 36.9831C28.6467 43.3319 36.4235 41.893 36.4235 41.893C38.796 41.6733 40.2569 40.0806 39.2464 37.5872C38.7192 36.3899 39.2684 35.621 39.6528 34.94C40.7842 32.9189 39.1146 32.4686 39.1036 31.0516C39.1036 30.4365 39.6089 29.9422 40.213 29.8763C41.1247 29.7775 41.9155 29.382 42.3989 28.8877C42.8162 28.4593 42.8602 27.7893 42.5416 27.284C38.6203 20.9022 39.1805 22.1654 38.0162 14.2129C36.4784 3.52525 26.0544 -1.01122 16.1467 1.1307C1.16423 4.38202 -3.10862 19.4303 3.88831 31.3702C5.42609 33.9954 5.77759 37.2467 4.66818 40.2454L1.27407 49.3842"
        stroke={color}
        strokeWidth="1.23023"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24.4418 38.6523C24.4418 38.6523 21.1795 42.1453 21.2674 49.3839"
        stroke={color}
        strokeWidth="1.23023"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.4297 29.2734C47.4402 30.8442 48.0334 32.7005 48.0334 34.7106C48.0334 36.7207 47.4402 38.577 46.4297 40.1478"
        stroke={color}
        strokeWidth="1.23023"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.8906 26.4941C51.4174 28.8667 52.3071 31.6787 52.3071 34.7103C52.3071 37.7419 51.4174 40.5539 49.8906 42.9265"
        stroke={color}
        strokeWidth="1.23023"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.4297 32.502C43.8361 33.139 44.0778 33.8969 44.0778 34.7098C44.0778 35.5226 43.8361 36.2805 43.4297 36.9176"
        stroke={color}
        strokeWidth="1.23023"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1753_14971">
        <rect width="52.9218" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default GearInsidePersonTalkingSVG;
